export default "__VITE_ASSET__T0QNmdvC__"